import React from 'react';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { TextField } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import Button from '../../common/Button';
import { SearchBusinessFormType } from '../../../types/business.type';

const SearchBusinessComponentStyle = styled.div`
    width: 100%;
    .formStyle {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .text-field {
        width: 100%;
    }
`;

const StyledButton = muiStyled(Button)({
    background: 'green',
    borderRadius: 3,
    border: 0,
    color: 'white',
    height: 30,
    width: '2px',
    marginLeft: '50px',
    textTransform: 'capitalize',
    '&:hover': {
        backgroundColor: 'green',
    },
});

interface SearchBusinessPropsType {
    searchBusiness: (businessName: string) => void;
    initBusinessList: () => void;
    checkSearchValue: (event: any) => void;
    isSearchButtonEnable: boolean;
}

const SearchBusinessComponent = ({
    searchBusiness,
    checkSearchValue,
    isSearchButtonEnable,
}: SearchBusinessPropsType) => {
    const { errors, register, handleSubmit } = useForm({
        defaultValues: {
            searchBusinessName: '',
        },
        mode: 'onSubmit',
    });
    const searchBusinessSubmit = handleSubmit((formVule: SearchBusinessFormType) => {
        searchBusiness(formVule.searchBusinessName);
    });

    return (
        <SearchBusinessComponentStyle>
            <form className="formStyle" onSubmit={searchBusinessSubmit}>
                <TextField
                    inputRef={register}
                    name="searchBusinessName"
                    label="Business Name"
                    className="text-field"
                    onChange={checkSearchValue}
                    error={!!errors.searchBusinessName}
                    helperText={errors.searchBusinessName?.message}
                />
                <StyledButton type="submit" color="primary" disabled={!isSearchButtonEnable}>
                    <SearchIcon />
                </StyledButton>
            </form>
        </SearchBusinessComponentStyle>
    );
};

export default SearchBusinessComponent;
